export let oneNoteAppName = "YJiec";
export default {oneNoteAppName};